import Dropzone from 'react-dropzone';
import { Link } from 'gatsby';

import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import ButtonLink from '../components/ui/ButtonLink';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

import { colors } from '../styles/colors';

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: -2.5rem auto 0;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem !important;

}
h2 {
  margin-top: 0;
  font-size: 3rem;

  small {
    font-size: 1.5rem;
    font-weight: normal;
  }
}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}
`;

const FactsBox = styled.div`
  margin-top: 1.5rem;
  background: #EFFAF2;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const DropZoneDiv = styled.div`
cursor: pointer;
border: 2px dashed  ${colors.beta};
background: repeating-linear-gradient(
  45deg,
  transparent,
  transparent 35px,
  ${colors.beta} 0,
  ${colors.beta} 70px
);
  max-width: 600px;
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  p {
    margin-bottom: 0;
    font-weight: bold;
  }
`;

const Logo = styled.div`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin: 0 auto 2rem;
  background: linear-gradient(45deg, #753300, #c75600, #d07e3e);
  box-shadow: rgba(39, 44, 49, 0.08) 0px 0px 28px, rgba(39, 44, 49, 0.06) 1px 3px 8px;
`;

const WrapThumbnails = styled.div`
  display: flex;
  margin: 3rem 0 2rem;
  padding: 0 0 3.2rem;
  overflow-x: scroll;
  scrollbar-color: #D7F2DE #f2eaf8;
  scrollbar-width: auto;
  position: relative;

  -webkit-mask-image: linear-gradient(
    to left,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
  mask-image: linear-gradient(to left, transparent 0%, black 10%, black 90%, transparent 100%);

  img {
    object-fit: cover;
    width: 100px;
    height: 100px;
    min-width: 100px;
    max-width: 100px;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 0.35rem;
  }
  img.active {
    border: 2px dashed;
  }
`;

interface ResultImgProps {
  activeFilter: number;
}

const ResultImg = styled.img<ResultImgProps>`
  max-height: 800px;
  object-fit: cover;

  filter: url(#filter-${props => props.activeFilter});

  :active {
    filter: none;
  }
`;

const ThumbImg1 = styled.img`
  filter: url(#filter-1);
`;
const ThumbImg2 = styled.img`
  filter: url(#filter-2);
`;
const ThumbImg3 = styled.img`
  filter: url(#filter-3);
`;

const ThumbImg4 = styled.img`
  filter: url(#filter-4);
`;
const ThumbImg5 = styled.img`
  filter: url(#filter-5);
`;
const ThumbImg6 = styled.img`
  filter: url(#filter-6);
`;
const ThumbImg7 = styled.img`
  filter: url(#filter-7);
`;
const ThumbImg8 = styled.img`
  filter: url(#filter-8);
`;
const ThumbImg9 = styled.img`
  filter: url(#filter-9);
`;
const ThumbImg10 = styled.img`
  filter: url(#filter-10);
`;
const ThumbImg11 = styled.img`
  filter: url(#filter-11);
`;
const ThumbImg12 = styled.img`
  filter: url(#filter-12);
`;
const ThumbImg13 = styled.img`
  filter: url(#filter-13);
`;
const ThumbImg14 = styled.img`
  filter: url(#filter-14);
`;
const ThumbImg15 = styled.img`
  filter: url(#filter-15);
`;
const ThumbImg16 = styled.img`
  filter: url(#filter-16);
`;
const ThumbImg17 = styled.img`
  filter: url(#filter-17);
`;
const ThumbImg18 = styled.img`
  filter: url(#filter-18);
`;

interface ColorGradingHelperState {
  hasCustomImage: boolean;
  photoData: any;
  active: number;
  downloadUrl: string;
}

class ColorGradingHelper extends React.Component<undefined, ColorGradingHelperState> {
  state = {
    hasCustomImage: false,
    photoData: undefined,
    active: 1,
    downloadUrl: '',
  };

  exampleUrl = '/guide/images/color-grade/example/color-grade-example-2.jpg';
  photoRef;
  canvasRef;

  // descriptions = [
  //   'low contrast',
  //   'super low contrast',
  //   'faded whites',
  //   'faded blacks',
  //   'red filter',
  //   'green filter',
  //   'blue filter',
  //   'low contrast red filter',
  //   'low contrast green filter',
  //   'low contrast blue filter',
  //   'infrared',
  //   'darker mid-tones',
  //   'high contrast',
  //   'super high contrast',
  //   'extreme high contrast',
  //   'vintage',
  // ];

  constructor(props) {
    super(props);
    this.photoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  setActive = (filterNb: number) => {
    this.setState({ active: filterNb });

    setTimeout(() => {
      const downloadUrl = this.downloadPhoto();
      this.setState({ downloadUrl });
    }, 0);
  };

  onDrop = file => {
    const reader = new FileReader();

    // reader.onabort = () => console.log('file reading was aborted');
    // reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      this.setState({ photoData: reader.result });

      setTimeout(() => {
        const downloadUrl = this.downloadPhoto();
        this.setState({ downloadUrl });
      }, 0);
    };

    reader.readAsDataURL(file[0]);
  };

  downloadPhoto = () => {
    const canvas = this.canvasRef.current;
    const photo = this.photoRef.current;
    const { naturalWidth, naturalHeight } = photo;

    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    photo.style.maxWidth = 'none';
    photo.style.maxHeight = 'none';
    photo.style.width = naturalWidth;
    photo.style.height = naturalHeight;

    const ctx = canvas.getContext('2d');
    ctx.filter = `url(#filter-${this.state.active})`;
    ctx.drawImage(photo, 0, 0, photo.width, photo.height);

    photo.style.maxWidth = '100%';
    photo.style.maxHeight = '800px';

    return canvas.toDataURL('image/jpeg');
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Online Color Grading Helper with Free Photoshop Actions | Giggster</title>
          <meta
            name="description"
            content="Use this free tool to preview different color combinations for your color grades. Once you're happy, download the Photoshop action and apply it to your photo."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta
            property="og:title"
            content="Online Color Grading Helper with Free Photoshop Actions"
          />
          <meta
            property="og:description"
            content="Use this free tool to preview different color combinations for your color grades. Once you're happy, download the Photoshop action and apply it to your photo."
          />
          <meta property="og:url" content="https://giggster.com/guide/color-grading/" />
          <meta property="og:image" content="https://giggster.com/guide/covers/color-grading.jpg" />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Online Color Grading Helper with Free Photoshop Actions"
          />
          <meta
            name="twitter:description"
            content="Use this free tool to preview different color combinations for your color grades. Once you're happy, download the Photoshop action and apply it to your photo."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/color-grading/" />
          <meta name="twitter:image" content="https://giggster.com/guide/covers/color-grading.jpg" />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>
                  <Logo />
                  Online Color Grading Helper with Free Photoshop Actions
                </PostFullTitle>
                <p className="t2">
                  Quickly preview different color grading color combinations for your photos and
                  apply them in Photoshop using a free action.{' '}
                  <a href="#how-it-works">Learn how it works here</a>.
                </p>
                {/*<ShareButtons
                  title={'Online Color Grading Helper with Free Photoshop Actions'}
                  slug={'/color-grading/'}
                  imgSrc={'covers/color-grading.jpg'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <h2 className="text-center">Upload Your Image</h2>

                  <Dropzone multiple={false} accept="image/jpeg, image/png" onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <DropZoneDiv {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>Drag a photo here, or click to select one</p>
                        </DropZoneDiv>
                      </section>
                    )}
                  </Dropzone>

                  <hr />

                  <WrapThumbnails>
                    <ThumbImg1
                      className={this.state.active === 1 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(1)}
                    />
                    <ThumbImg2
                      className={this.state.active === 2 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(2)}
                    />
                    <ThumbImg3
                      className={this.state.active === 3 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(3)}
                    />
                    <ThumbImg4
                      className={this.state.active === 4 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(4)}
                    />
                    <ThumbImg5
                      className={this.state.active === 5 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(5)}
                    />
                    <ThumbImg6
                      className={this.state.active === 6 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(6)}
                    />
                    <ThumbImg7
                      className={this.state.active === 7 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(7)}
                    />
                    <ThumbImg8
                      className={this.state.active === 8 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(8)}
                    />
                    <ThumbImg9
                      className={this.state.active === 9 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(9)}
                    />

                    <ThumbImg10
                      className={this.state.active === 10 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(10)}
                    />
                    <ThumbImg11
                      className={this.state.active === 11 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(11)}
                    />

                    <ThumbImg12
                      className={this.state.active === 12 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(12)}
                    />
                    <ThumbImg13
                      className={this.state.active === 13 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(13)}
                    />
                    <ThumbImg14
                      className={this.state.active === 14 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(14)}
                    />

                    <ThumbImg15
                      className={this.state.active === 15 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(15)}
                    />

                    <ThumbImg16
                      className={this.state.active === 16 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(16)}
                    />
                    <ThumbImg17
                      className={this.state.active === 17 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(17)}
                    />
                    <ThumbImg18
                      className={this.state.active === 18 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(18)}
                    />
                  </WrapThumbnails>

                  {this.state.photoData ? (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.state.photoData}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                      ref={this.photoRef}
                    />
                  ) : (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.exampleUrl}
                      ref={this.photoRef}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                    />
                  )}
                  <h2 className="text-center">
                    Color Grade #{this.state.active}
                    <br />
                    <small>(tap/click on image to view original)</small>
                  </h2>

                  <p>
                    <ButtonLink
                      href="https://purple11.s3.amazonaws.com/actions/purple11-color-grading.zip"
                      download
                    >
                      Download Photoshop Actions
                    </ButtonLink>{' '}
                    {this.state.downloadUrl ? (
                      <>
                        <ButtonLink
                          href={this.state.downloadUrl}
                          download={`color-grade-${this.state.active}.jpg`}
                        >
                          Download Photo
                        </ButtonLink>
                        <br />
                        <small>
                          Note that downloading the photo directly only works in Chrome or Firefox
                          for now
                        </small>
                      </>
                    ) : (
                      ''
                    )}
                  </p>

                  <hr />

                  <FactsBox>
                    <h3 name="how-it-works">How the color grading tool works</h3>
                    <ul>
                      <li>
                        &#9673; With this online tool, you can upload a Jpeg image and quickly
                        preview different color toning variations. Click on the preview image to
                        toggle between the original and the color graded photo.
                      </li>
                      <li>
                        &#9673; The tool applies different color grading color combinations using
                        gradient maps. I tried to create a good mixture of grades with
                        complementary, analogous and monochromatic colors. Some have a cooling
                        effect, some have a warming effect, and some have both a cooling and warming
                        effect depending on the underlining tonal values.
                      </li>

                      <li>
                        &#9673; To get started, download the{' '}
                        <a
                          href="https://purple11.s3.amazonaws.com/actions/purple11-color-grading.zip"
                          download
                        >
                          free Photoshop actions
                        </a>
                        . Unzip the file and double click on the action file to install it, or go in
                        Photoshop into the action panel's menu and choose <em>Load Actions...</em>
                      </li>

                      <li>
                        &#9673; When you're happy with a specific color grade, you can either
                        download the color graded photo directly{' '}
                        <strong>(only available in Chrome and Firefox for the moment)</strong>, or
                        play the action with the corresponding number (e.g.: Color Grade #10) in
                        Photoshop.
                      </li>
                      <li>
                        &#9673; If you decide to use the corresponding action, feel free to tweak
                        the opacity of the color grading layer. You can also tweak the color stops
                        in the applied gradient map, if you want to adjust the colors. Plus, you'll
                        notice that the color grade layer uses a gradient map set to a blend mode of{' '}
                        <em>Soft Light</em>. Feel free to also try out a blend mode of{' '}
                        <em>Hard Light</em> instead, for a more contrasty/punchy look. This allows
                        you full flexibility to adjust the color grading effect to work perfectly
                        with your specific photograph.
                      </li>
                    </ul>
                  </FactsBox>
                  <hr />
                 
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="color-grading" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>

        <canvas ref={this.canvasRef} style={{ display: 'none' }} />
        <svg version="1.1" width="0" height="0">
          {/* start of complimentary grades */}
          {/* soft light, 50% (blue/orange), Color stops: #006EB3, #B36800 */}
          <filter id="filter-1" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.7" />
              <feFuncG type="table" tableValues="0.43 0.41" />
              <feFuncB type="table" tableValues="0.7 0" />
              <feFuncA type="table" tableValues="0 0.5" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 100% (teal green/salmon), Color stops: #00B37E, #FF6438 */}
          <filter id="filter-2" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />

            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0.7 0.39" />
              <feFuncB type="table" tableValues="0.49 0.22" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 100% (earth orange/powder blue), Color stops: #B37700, #3887FF */}
          <filter id="filter-3" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.7 0.22" />
              <feFuncG type="table" tableValues="0.47 0.53" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 100% (deep marron/electric blue), Color stops: #B33E00, #38FFF7 */}
          <filter id="filter-4" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.7 0.22" />
              <feFuncG type="table" tableValues="0.24 1" />
              <feFuncB type="table" tableValues="0 0.97" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* start of analogous grades */}
          {/* soft light, 100% (blue/electric blue), Color stops: #2C0DFF, #0DEDFF */}
          <filter id="filter-5" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.17 0.05" />
              <feFuncG type="table" tableValues="0.05 0.93" />
              <feFuncB type="table" tableValues="1 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 60% (crocodile green/lime green), Color stops: #089955, #BCFF0D */}
          <filter id="filter-6" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.03 0.74" />
              <feFuncG type="table" tableValues="0.6 1" />
              <feFuncB type="table" tableValues="0.33 0.05" />
              <feFuncA type="table" tableValues="0 0.6" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 50% (vomit brown/orange crush), Color stops: #948107, #FD700D */}
          <filter id="filter-7" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.58 0.99" />
              <feFuncG type="table" tableValues="0.51 0.44" />
              <feFuncB type="table" tableValues="0.03 0.05" />
              <feFuncA type="table" tableValues="0 0.5" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 30% (bright marron/purple), Color stops: #D40B62, #760BE3 */}
          <filter id="filter-8" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.83 0.46" />
              <feFuncG type="table" tableValues="0.04 0.04" />
              <feFuncB type="table" tableValues="0.38 0.89" />
              <feFuncA type="table" tableValues="0 0.3" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" result="blend" />
          </filter>

          {/* start of analogous monochromatic grades */}
          {/* soft light, 50% (navy blue/kinda powder blue), Color stops: #001D7A, #4B74FB */}
          <filter id="filter-9" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.29" />
              <feFuncG type="table" tableValues="0.11 0.45" />
              <feFuncB type="table" tableValues="0.48 0.98" />
              <feFuncA type="table" tableValues="0 0.5" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 100% (Teal green/electric green), Color stops: #006E7A, #4BE9FB */}
          <filter id="filter-10" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.29" />
              <feFuncG type="table" tableValues="0.43 0.91" />
              <feFuncB type="table" tableValues="0.48 0.98" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 60% (croco green/electric lime green), Color stops: #007A49, #4BFBB5 */}
          <filter id="filter-11" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.29" />
              <feFuncG type="table" tableValues="0.48 0.98" />
              <feFuncB type="table" tableValues="0.29 0.71" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 60% (vomit green/electric yellow), Color stops: #6E7A00, #E9FB4B */}
          <filter id="filter-12" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.43 0.91" />
              <feFuncG type="table" tableValues="0.48 0.98" />
              <feFuncB type="table" tableValues="0 0.29" />
              <feFuncA type="table" tableValues="0 0.6" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 50% (brown/pale orange), Color stops: #7A5000, #FBBD4B */}
          <filter id="filter-13" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.48 0.98" />
              <feFuncG type="table" tableValues="0.31 0.74" />
              <feFuncB type="table" tableValues="0 0.29" />
              <feFuncA type="table" tableValues="0 0.5" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 20% (marron/red), Color stops: #800D00, #FF1B00 */}
          <filter id="filter-14" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.5 1" />
              <feFuncG type="table" tableValues="0.05 0.11" />
              <feFuncB type="table" tableValues="0 0" />
              <feFuncA type="table" tableValues="0 0.2" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* soft light, 30% (deep purple/pale purple), Color stops: #370080, #9A4DFF */}
          <filter id="filter-15" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.22 0.6" />
              <feFuncG type="table" tableValues="0 0.3" />
              <feFuncB type="table" tableValues="0.5 1" />
              <feFuncA type="table" tableValues="0 0.3" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>

          {/* start of triad grades */}
          {/* soft light, 30% (blue/orange/pale green), Color stops: #124DB3, #FF3919, #98CC14 */}
          <filter id="filter-16" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.07 1 0.6" />
              <feFuncG type="table" tableValues="0.3 0.22 0.8" />
              <feFuncB type="table" tableValues="0.7 0.1 0.08" />
              <feFuncA type="table" tableValues="0 0.3" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>
          {/* soft light, 50%, Color stops: #124DB3, #FF3919, #98CC14 */}
          <filter id="filter-17" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.48 0.14 0.78" />
              <feFuncG type="table" tableValues="0.29 0.82 0.45" />
              <feFuncB type="table" tableValues="0.08 0.27 0.05" />
              <feFuncA type="table" tableValues="0 0.5" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>
          {/* soft light, 70%, Color stops: #0C667A, #00A3C7, #94880F */}
          <filter id="filter-18" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.05 0 0.58" />
              <feFuncG type="table" tableValues="0.4 0.64 0.53" />
              <feFuncB type="table" tableValues="0.48 0.78 0.06" />
              <feFuncA type="table" tableValues="0 0.7" />
            </feComponentTransfer>
            <feBlend mode="soft-light" in="componentTransfer" in2="SourceGraphic" />
          </filter>
        </svg>
      </IndexLayout>
    );
  }
}

export default ColorGradingHelper;
